import React from "react";
import { GalleryIcon, ScheduleIcon, MenuIcon, BingoIcon, SeatingIcon, BarIcon } from "../icons";
import "./Navigation.css";

const TABS = [
  { id: "gallery",  label: "Galeria",      Icon: GalleryIcon  },
  { id: "schedule", label: "Harmonogram",  Icon: ScheduleIcon },
  { id: "menu",     label: "Karta Dań",    Icon: MenuIcon     },
  { id: "bingo",    label: "Bingo",        Icon: BingoIcon    },
  { id: "seating",  label: "Rozsadzenie",  Icon: SeatingIcon  },
  { id: "bar",      label: "Bar",          Icon: BarIcon      },
];

export default function Navigation({ active, onChange }) {
  return (
    <nav className="nav">
      <div className="nav__track">
        {TABS.map(({ id, label, Icon }) => (
          <button
            key={id}
            className={`nav__btn ${active === id ? "nav__btn--active" : ""}`}
            onClick={() => onChange(id)}
          >
            <span className="nav__icon"><Icon /></span>
            <span className="nav__label">{label}</span>
            {active === id && <span className="nav__indicator" />}
          </button>
        ))}
      </div>
    </nav>
  );
}
